(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[120],{

/***/ 2444:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageItemById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PageItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"resolve_links"},"value":{"kind":"StringValue","value":"url","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocks"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"component"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_uid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_editable"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default_full_slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"first_published_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"full_slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"group_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_startpage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lang"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta_data"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parent_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"release_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sort_by_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tag_list"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"translated_slugs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lang"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":640}};
    doc.loc.source = {"body":"query GetPageItemById($id: ID!) {\n    PageItem(id: $id, resolve_links: \"url\") {\n        content {\n            blocks\n            component\n            metadata\n            _uid\n            _editable\n        }\n        created_at\n        default_full_slug\n        first_published_at\n        full_slug\n        group_id\n        id\n        is_startpage\n        lang\n        meta_data\n        name\n        parent_id\n        position\n        path\n        published_at\n        release_id\n        slug\n        sort_by_date\n        tag_list\n        translated_slugs {\n            lang\n            name\n            path\n        }\n        uuid\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.GetPageItemById = oneQuery(doc, "GetPageItemById");
        


/***/ }),

/***/ 9335:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(5262);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ek": function() { return /* binding */ usePageItem; }
/* harmony export */ });
/* unused harmony exports generatePageQueryKey, fetchPageItem */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5163);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4830);
/* harmony import */ var _GetPageItemById_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2444);
/* harmony import */ var _GetPageItemById_graphql__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_GetPageItemById_graphql__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_storyblok__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1379);
/* harmony import */ var _utils_errors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7884);






var generatePageQueryKey = function(param) {
    var id = param.id, locale = param.locale;
    return [
        "page-content",
        id,
        locale
    ];
};
var fetchPageItem = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var preview, id, PageItem, error, errorMessage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    preview = param.preview, id = param.id;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_utils_storyblok__WEBPACK_IMPORTED_MODULE_1__/* .storyblokGraphQLClient */ .dA)(preview).request((_GetPageItemById_graphql__WEBPACK_IMPORTED_MODULE_0___default()), {
                            id: id
                        })
                    ];
                case 2:
                    PageItem = _state.sent().PageItem;
                    return [
                        2,
                        PageItem
                    ];
                case 3:
                    error = _state.sent();
                    errorMessage = (0,_utils_errors__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(error);
                    console.error({
                        message: errorMessage
                    });
                    throw new Error(errorMessage);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPageItem(_) {
        return _ref.apply(this, arguments);
    };
}();
// Get page content by page id (full_slug)
// Generates query key using id and locale with page-content prefixed
var usePageItem = function(param) {
    var id = param.id, locale = param.locale, preview = param.preview;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a)(generatePageQueryKey({
        id: id,
        locale: locale
    }), function() {
        return fetchPageItem({
            preview: preview,
            id: id
        });
    });
};


/***/ }),

/***/ 5262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _storyblok_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4332);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1960);
/* harmony import */ var _utils_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9429);
/* harmony import */ var _hooks_pages_usePageItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(459);






var __N_SSG = true;
function Page(param) {
    var slug = param.slug, locale = param.locale, preview = param.preview;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,_hooks_pages_usePageItem__WEBPACK_IMPORTED_MODULE_5__/* .usePageItem */ .ek)({
        id: slug,
        locale: locale,
        preview: preview
    }), storyData = ref4.data;
    var story = (0,_storyblok_react__WEBPACK_IMPORTED_MODULE_2__/* .useStoryblokState */ .f0)(storyData);
    var metaTitle = (story === null || story === void 0 ? void 0 : (ref = story.content) === null || ref === void 0 ? void 0 : ref.title) ? "".concat(story === null || story === void 0 ? void 0 : (ref1 = story.content) === null || ref1 === void 0 ? void 0 : ref1.title.trim(), " | ").concat(_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].appName */ .Z.appName) : _config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].appName */ .Z.appName;
    var metaDescription = (story === null || story === void 0 ? void 0 : (ref2 = story.content) === null || ref2 === void 0 ? void 0 : ref2.intro) ? story.content.intro.trim() : _config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].appDescription */ .Z.appDescription;
    var canonicalUrl = (story === null || story === void 0 ? void 0 : story.full_slug) ? "".concat(_utils_environment__WEBPACK_IMPORTED_MODULE_4__/* .ORIGIN */ .jQ, "/").concat(story.full_slug) : _utils_environment__WEBPACK_IMPORTED_MODULE_4__/* .ORIGIN */ .jQ;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        property: "title",
                        content: metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "og:title",
                        property: "og:title",
                        content: metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }),
                    metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "description",
                                property: "description",
                                content: metaDescription
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "og:description",
                                property: "og:description",
                                content: metaDescription
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:description",
                                property: "twitter:description",
                                content: metaDescription
                            })
                        ]
                    }),
                    canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "og:url",
                                property: "og:url",
                                content: canonicalUrl
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:url",
                                property: "twitter:url",
                                content: canonicalUrl
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: canonicalUrl
                            })
                        ]
                    }),
                    (story === null || story === void 0 ? void 0 : (ref3 = story.content) === null || ref3 === void 0 ? void 0 : ref3.image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "og:image",
                                property: "og:image",
                                content: story.content.image
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:image",
                                property: "twitter:image",
                                content: story.content.image
                            })
                        ]
                    })
                ]
            }),
            (storyData === null || storyData === void 0 ? void 0 : storyData.content) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storyblok_react__WEBPACK_IMPORTED_MODULE_2__/* .StoryblokComponent */ .Xj, {
                blok: story.content
            }, story.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Add blocks to this page"
            })
        ]
    });
}


/***/ }),

/***/ 7884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getErrorMessage; }
/* harmony export */ });
// Type guard to check for message in error
function isErrorWithMessage(error) {
    return typeof error === "object" && error !== null && "message" in error && typeof error.message === "string";
}
function toErrorWithMessage(maybeError) {
    if (isErrorWithMessage(maybeError)) {
        return maybeError;
    }
    try {
        return new Error(JSON.stringify(maybeError));
    } catch (e) {
        // fallback in case there's an error stringifying the maybeError
        // like with circular references for example.
        return new Error(String(maybeError));
    }
}
function getErrorMessage(error) {
    return toErrorWithMessage(error).message;
}


/***/ }),

/***/ 7729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5913)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [830,774,888,179], function() { return __webpack_exec__(9335); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);